
import { WorldCountry } from '../types';

export const egyptData: WorldCountry = {
  code: 'EG',
  name: 'Egypt',
  slug: 'egypt',
  population: 102334404,
  topCities: [
    { name: 'Cairo', slug: 'cairo', population: 20900604 },
    { name: 'Alexandria', slug: 'alexandria', population: 5200000 },
    { name: 'Giza', slug: 'giza', population: 4367343 },
    { name: 'Shubra El Kheima', slug: 'shubra-el-kheima', population: 1165573 },
    { name: 'Port Said', slug: 'port-said', population: 749371 },
    { name: 'Suez', slug: 'suez', population: 728180 },
    { name: 'Luxor', slug: 'luxor', population: 506588 },
    { name: 'al-Mansura', slug: 'al-mansura', population: 496231 },
    { name: 'El-Mahalla El-Kubra', slug: 'el-mahalla-el-kubra', population: 462300 },
    { name: 'Tanta', slug: 'tanta', population: 445287 },
    { name: 'Asyut', slug: 'asyut', population: 389307 },
    { name: 'Ismailia', slug: 'ismailia', population: 374285 },
    { name: 'Fayyum', slug: 'fayyum', population: 365000 },
    { name: 'Zagazig', slug: 'zagazig', population: 353632 },
    { name: 'Aswan', slug: 'aswan', population: 290327 },
    { name: 'Damietta', slug: 'damietta', population: 263285 },
    { name: 'Damanhur', slug: 'damanhur', population: 249309 },
    { name: 'al-Minya', slug: 'al-minya', population: 236943 },
    { name: 'Beni Suef', slug: 'beni-suef', population: 230793 },
    { name: 'Qena', slug: 'qena', population: 206831 },
    { name: 'Sohag', slug: 'sohag', population: 189695 },
    { name: 'Hurghada', slug: 'hurghada', population: 248000 },
    { name: 'Shibin El Kom', slug: 'shibin-el-kom', population: 159909 },
    { name: 'Banha', slug: 'banha', population: 167029 },
    { name: 'Kafr el-Sheikh', slug: 'kafr-el-sheikh', population: 147393 },
    { name: 'Arish', slug: 'arish', population: 164830 },
    { name: 'Mallawi', slug: 'mallawi', population: 137817 },
    { name: 'Bilqas', slug: 'bilqas', population: 136618 },
    { name: 'Marsa Matruh', slug: 'marsa-matruh', population: 76422 },
    { name: 'Idfu', slug: 'idfu', population: 60061 },
    { name: 'Mit Ghamr', slug: 'mit-ghamr', population: 101801 },
    { name: 'al-Hamidiyya', slug: 'al-hamidiyya', population: 95666 },
    { name: 'Desouk', slug: 'desouk', population: 137660 },
    { name: 'Qalyub', slug: 'qalyub', population: 84413 },
    { name: 'Abu Kabir', slug: 'abu-kabir', population: 130023 },
    { name: 'Kafr Dawar', slug: 'kafr-dawar', population: 265300 },
    { name: 'Dikirnis', slug: 'dikirnis', population: 67736 },
    { name: 'Aja', slug: 'aja', population: 72002 },
    { name: 'Girga', slug: 'girga', population: 103124 },
    { name: 'Edfu', slug: 'edfu', population: 60061 },
    { name: 'Rosetta', slug: 'rosetta', population: 69283 },
    { name: 'Balyana', slug: 'balyana', population: 67837 },
    { name: 'Manfalut', slug: 'manfalut', population: 85010 },
    { name: 'Samalut', slug: 'samalut', population: 79851 },
    { name: 'Akhmim', slug: 'akhmim', population: 101509 },
    { name: 'Qus', slug: 'qus', population: 110431 },
    { name: 'Nag Hammadi', slug: 'nag-hammadi', population: 103997 },
    { name: 'Tahta', slug: 'tahta', population: 67032 },
    { name: 'Kom Ombo', slug: 'kom-ombo', population: 60068 },
    { name: 'Esna', slug: 'esna', population: 71027 }
  ]
};
